import { render, staticRenderFns } from "./AllMusic.vue?vue&type=template&id=148a10a4&scoped=true&"
import script from "./AllMusic.vue?vue&type=script&lang=js&"
export * from "./AllMusic.vue?vue&type=script&lang=js&"
import style0 from "./AllMusic.vue?vue&type=style&index=0&id=148a10a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148a10a4",
  null
  
)

export default component.exports